import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';


class Certificateinbigdatahadoop extends Component {
    render() {
        return (
            <div>

                <div aria-label="breadcrumb">
                <ol class="breadcrumb">
                <li class="breadcrumb-item"> <Link href=""><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                    <li class="breadcrumb-item active" aria-current="page">Certificate course in Big Data Hadoop</li>
                </ol>
                </div>

                <section class="course-header bg-yellow11" id="course-header">
               <div class="row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 six-sigma-bkg">
                     <h1>Certificate course in Big Data Hadoop<br /></h1><br /><br />
                     <p>Accelerate your Career. Stay Ahead of the Curve </p>
                     <br /><br />
                     <div class="form-group">
                        <a href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </a>
                       <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                           data-target="#myModal"  onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/certificate-course-in-big-data-hadoop');">Download
                        brochure</button> <br /><br /><br /><br />
                      </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                  <p>Jointly Delivered by eduplusnow and Industry Expert  </p>
                     <br />
                     <table class="table-highlight">
                        <tr>
                           <td> <img alt="executive2" width="" src="/assets/images/epn.svg" /></td>
                        </tr>
                     </table>
                     <br />
                  </div>
               </div>
            </section>
            <div class="course-main-contains def-z">
                <div class="card" id="Description">
                    <div class="row contanint-display">
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                        <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;36 hours<br />
                        <i class="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKDAY BATCH</b>  
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                        <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;36 hours<br />
                        <i class="fa fa-tasks" ></i> &nbsp;&nbsp; WEEKEND BATCH</b>
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" id="Description">    
                        
                        </div>
                    </div>
                </div>
            </div>
            <section class="def-z">
            <div class="header" id="myHeader">
                    <ul>
                        <li><a href="#Description">Description</a></li>
                        <li><a href="#Trends">Industry Trends</a></li>
                        <li><a href="#tools">Tools</a></li>
                        <li><a href="#syllabus">Syllabus</a></li>               
                        <li><a href="#Outcomes">Learning Outcomes</a></li>           
                        <li><a href="#Review">Learner Review</a></li>          
                        <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>           
                    </ul>
            </div>
            </section>
            <br />
            <br />
            <section class="course-description" id="course-description">
               <div class="row">
                  <div class="col-sm-12">
                     <h3>Description</h3>
                     <p align = "justify" class="Descriptionbold">The Big Data Hadoop is created & delivered by edu plus now along with industry experts.</p>
                     <p align = "justify">Big Data Hadoop training is designed to give you an in depth knowledge of Big Data fand Hadoop Ecosystem tools such as HDFS, YARN, MapReduce, Hive, Pig,Flume & Scoop</p>
                  </div>
                 
               </div>
               <br/>
               <div class="row">
                  <div class="col-sm-12">
                     <h3 class="heading-tab">Course Features</h3>
                     <ul class="highlight-ul" >
                        <li>Eduplusnow's Bigdata Hadoop training course will master the concepts of Hadoop framework, Big Data tools and methodology to prepare you for the success as Big data Developer role</li>
                     </ul>
                  </div>
               
               </div> <br/>
               <div class="row">
                  <div class="col-sm-6">
                     <h5  id="Trends"> Who Should Enroll? </h5>
                     <ul class="admission-ul">
                        <li>Ideal for any freshers, programmers, software developers, testing professionals , IT Data Management and analytics professionals looking to gain expertise in Big Data Haoop. </li>
                     </ul>
                  </div>
                  <br />
                  <div class="col-sm-6">
                     <h5> Eligibility </h5>
                     <ul class="admission-ul">
                        <li>Pre requisites for Big Data Hadoop training should have basic understanding of Core Java, basic linux commands and SQL. </li>
                     </ul>
                  </div>
               </div>
            
               <br/>
            </section>
           
            <section class="course-industry-trends bg-secondary" id="course-industry-trends">
               <div class="row">
                  <div class=" col-md-6 col-sm-12">
                     <h3> Industry Trends </h3>
                     <br />
                     <h5>Job Roles</h5>
                     <ul class="industry-trends-ul">
                        <li>Hadoop Developer</li>
                        <li id="tools"> Big Data Engineer</li>
                        <li>Big Data Developer</li>
                     </ul>
                  </div>
                  <div class="col-md-6 col-sm-12">
                     <img alt="datascience11"src="</assets/images/icons/industry-trends.svg" />
                  </div>
               </div>
            </section>

            <br /> 
            <section class="course-tools-covered" id="course-tools-covered">
               <h3> Tools Covered </h3>
               <br />
               <div class="owl-carousel owl-theme" id="owl-carousel-course-tools">
                  <div class="item">
                     <div class="card">
                     <center id="syllabus">
                          <img  class="" alt="hadoop-logo" src="/assets/images/icons/hadoop-logo.png" /></center>
                     </div>
                  </div>
                  <div class="item">
                     <div class="card">
                     <center> <img  class="" alt="mapreduce" src="</assets/images/icons/mapreduce.png" /></center>
                     </div>
                  </div>
                  <div class="item">
                     <div class="card">
                     <center> <img class="" alt="hive" src="/assets/images/icons/hive.png" /></center>
                     </div>
                  </div>
                  <div class="item">
                     <div class="card">
                     <center> <img  class="" alt="Pig" src="/assets/images/icons/pig.png" /></center>
                     </div>
                  </div>
                  <div class="item">
                     <div class="card">
                     <center> <img  class="" alt="flume-scoop" src="/assets/images/icons/flume-scoop.jpg" /></center>
                     </div>
                  </div>
               </div>
            </section>
            
            <section class="course-syllabus" id="course-syllabus">
            <div class="row"  >
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10" >
                     <br />
                     <h3> Syllabus </h3>
                     <br />
                     <div class="syl-bg">
                     <div id="de_syllabus">
                        <div class="panel-group">
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                 href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Introduction
                                 </h6>
                              </div>
                              <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>Introduction to Big Data</li>
                                       <li>Role of Hadoop in Big Data</li>
                                       <li>Introduction of Hadoop</li>
                                       <li>Introduction to Hadoop Architecture</li>
                                    </ul>
                                 </div>
                              </div>
                           </div><br />
                    
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                 href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                 <h6 class="panel-title">
                                   <i class="indicator fa fa-minus"></i>  Introduction to HDFS
                                 </h6>
                              </div>
                              <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>HDFS writing process</li>
                                       <li>HDFS reading process</li>
                                       <li>Basic Linux commands  for Hadoop </li>
                                       <li>Basic hadoop commands</li>
                                       <li>Basic HDFS commands</li>
                                       <li>HDFS checkpointing process and secondary namenode</li>
                                       <li>Introduction to data processing in Hadoop </li>
                                       <li>Introduction to mapreduce alogrithm</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <ul class="syllabus-ul">
                                       <li><h5>Understanding Map reduce architecture</h5></li>
                              </ul>
                          
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                 href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> 
                                    Introduction to YARN as resource manager 
                                 </h6>
                              </div>
                              <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>understanding yarn architecture </li>
                                       <li>Introduction to Java for mapreduce </li>
                                       <li>Writing and understanding mapreduce programs </li>
                                       <li>Submitting map reduce job and understand the statistics </li>
                                       <li>Changing number of mappers and reducers and see the effect </li>
                                       <li>understanding the data ingestion to hadoop</li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                 href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>
                                     Introduction to Sqoop
                                 </h6>
                              </div>
                              <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>Architecture of sqoop </li>
                                       <li>Understanding of mysql, sql and data creation</li>
                                       <li>Sqoop import of a table from mysql </li>
                                       <li>Sqoop export of a table to mysql</li>
                                       <li>Sqoop import incremental data from a table from mysql</li>
                                       <li>Sqoop import incremental last modified data from mysql </li>
                                    </ul>
                                 </div>
                              </div>
                           </div><br/>
                           <h5> Introduction to Flume as data ingestion tool</h5>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading5" data-toggle="collapse"
                                 href="#de_syllabus5" aria-expanded="true" aria-controls="de_syllabus5">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Flume architecture 
                                 </h6>
                              </div>
                              <div id="de_syllabus5" class="collapse show" aria-labelledby="de_heading5"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>Flume data ingestion on console and in hdfs </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading6" data-toggle="collapse"
                                 href="#de_syllabus6" aria-expanded="true" aria-controls="de_syllabus6">
                                 <h6 class="panel-title">
                                   <i class="indicator fa fa-minus"></i> Introduction to Hive
                                 </h6>
                              </div>
                              <div id="de_syllabus6" class="collapse show" aria-labelledby="de_heading6"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>Architecture of Hive</li>
                                       <li>various data formats of hive (ORC, Parquet, AVRO)</li>
                                       <li>creation of hive databases and tables </li>
                                       <li>creation of hive tables (with different data formats) </li>
                                       <li>Introduction to hive partitioning and bucketing</li>
                                       <li>Introduction to hive indexing</li>
                                       <li>partitioning practicals with weather data set </li>
                                       <li>bucketing practicals with weather data set </li>
                                       <li>Various hive builtin functions</li>
                                       <li>Introduction to hive UDF, UDAF functions</li>
                                       <li>Writing hive UDF function</li>
                                       <li>Registering and using the UDF </li>
                                    </ul>
                                 </div>
                              </div>
                           </div><br/>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading7" data-toggle="collapse"
                                 href="#de_syllabus7" aria-expanded="true" aria-controls="de_syllabus7">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Introduction to PIG
                                 </h6>
                              </div>
                              <div id="de_syllabus7" class="collapse show" aria-labelledby="de_heading7"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                       <li>Loading data from HDFS in the PIG relation and apply tranformation </li>
                                       <li>Understanding Hcatalog (pig access hive tables) </li>
                                       <li>Loading data from hive tables in PIG relation and apply transformation </li>
                                       <li>Storing the data to hdfs and hive tables back from PIG relation </li>
                                       <li>Understanding the data set and ingest it to HDFS</li>
                                       <li id="Outcomes">Understanding the hive joins and pig scipts for data processing</li>
                                       <li>Execute the skynet project scripts and verifying the results</li>
                                       <li>Deriving and interpret the results of final execution</li>
                                    </ul>
                                 </div>
                              </div>
                           </div><br/>
                          
                        </div>
                        </div>
                        </div>
                        </div>
                     </div>
            </section>
          
            <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
            <div class="row">
            <div class="col-sm-6">
            <h3>Learning Outcomes</h3>
            <ul class="lo-ul">
            <li>By attending Bigdata Hadoop training at eduplusnow you will learn how various components of the Hadoop ecosystem fit into the Big Data Processing lifecycle. 
            </li>
            </ul>
            <br />
            <h5>Assessment </h5>
            <p align="justify"  id="Review">
            Periodic assessment and case studies evaluations by the edu plus now and Industry Expert have been built in throughout the duration of the course.
            </p>
            </div>
            <div class="col-sm-6">
            <img alt="datascience18"src="/assets/images/icons/certificate1.png" />
            <p class="img-below-text text-center">Awarded by edu plus now 
            </p>
            </div>
            </div>
            </section>

            <section class="course-admission-process" id="course-admission-process1">    
                <br />	
           </section>
           <Aboutuslearners />
            <Aluminicompany />
           <section class="courses-feesm">
           <section class="course-fees" id="course-fees">
           <div class="row box-sh" >
                  <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                
          
                  </div>
                   <div class="vertical-line-fee"> </div>
                   <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                       <div class="row">
                           <div class="col-sm-10"> <br /><br />
                               <h5>Features</h5>
                           </div>
                       </div>
                       <div class="row">
                           <div class="col-md-12 col-sm-12">
                           Eduplusnow's Bigdata Hadoop Training Course Will Master
                             <ul class="highlight-ss" >
                             
                                <li>	Concepts Of Hadoop Framework.</li>
                                <li>	Big Data Tools</li>
                                <li>	Methodology To Prepare You For The Success As Big Data Developer Role.</li>
                             </ul>
                           </div>
                          <p>{// eslint-disable-next-line
                             }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 "> &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                          </p>   
                           <p align = "justify" class="font-text-alumni" ><span >*</span>Alumni of Eduplusnow, VIT, VIIT, VU Will Get Special Discount, To Grab your Discount coupon Please Contact  &nbsp; <a href="tel://8956167195" class="contact-us-mobile"> <i class="fa fa-phone icon-tick"> </i>+918956167195. </a><br /></p>

                       </div>
                       </div>
               </div>
            </section> 
            </section> 
            <Whyedu />
                <section class="course-about-instructor bg-secondary " id="course-about-instructor">
                <div class="row">
                <div class="col-sm-12">
                <h3>
                About the Organization
                </h3>
                <br />
                <img alt="datascience23"width="200px" src="/assets/images/eduplusnow.png" />
                <br /><br />
                <p align="justify">edu plus now is an online educational platform that was launched in 2019 to bridge the skill gap between classroom learning, real business challenges and to help students achieve their career potential.
                </p>
                <br />
                <p align="justify">Aimed at providing learners with essential technical skills, edu plus now courses are created to be the perfect amalgamation of inputs from industry experts and highly-qualified professors from the country’s top educational institutions. This allows individuals and companies to close the skill gap quickly, innovate faster and achieve their key objectives. At edu plus now, we believe in preparing students for success in a changing world by providing online courses that pave the path for a successful career. Built under the aegis of the Vishwakarma Group, the online education platform provides flexible learning that fits a learner’s schedule. 
                </p>
                </div>
                </div>
                </section>
                
                <section>
                 
                </section>
                <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog">
                    <div class="modal-dialog modal-md">

                        <div class="modal-content">
                            <div class="modal-header" >
                                <span class="close" id="close_form"
                                    data-dismiss="modal">&times;</span>
                                <br />
                            </div>
                            <div class="modal-body" >
                                <div class="panel panel-default paper-shadow box_detail" >
                                    <h5 class="text-center "> Download The Course Brochure </h5>
                                    <form method="post" class="form-row"  onsubmit="return validate()">
                                    <b>Your Name</b>
                                    <input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                        required="" autocomplete="on" name="name" id="name" />
                                    <b>Your email</b><input class="form-control" type="email" required=""
                                        autocomplete="on" name="emaill" id="emaill" />
                                    <b>Your Contact No</b>
                                    <input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                        type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                    <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                                    <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                    <br />
                                    <div>
                                        <div class="form-group">
                                            <div id="recaptcha" class="g-recaptcha"
                                                data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                            <div id="captcha"></div>
                                        </div>
                                    </div>
                                   
                                    <div class="mob_cb">
                                        <div>
                                        </div>
                                        <br />
                                       
                                        <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button>
                                    </div>
                                   
                                    </form>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
            </div>
        );
    }
}

export default Certificateinbigdatahadoop;